<dashboardnav>
  <cradua-banking-status
  [bankingstatuss]="bankingstatuss$ | async"
  (bankingstatus)="onSubmitBankingStatus($event)"
  (deleteBankingStatusEvent)="onDeleteBankingStatus($event)"
  *ngIf="(isLoadingBankingStatus$ | async ) === false"
  >
</cradua-banking-status>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingBankingStatus$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
